module.exports = __webpack_public_path__ + "static/education-desktop.f371e63c.webp";